/*! DataTables styling integration
 * ©2018 SpryMedia Ltd - datatables.net/license
 */

import jQuery from 'jquery';
import DataTable from 'datatables.net';

// Allow reassignment of the $ variable
let $ = jQuery;




export default DataTable;



//////////////////
// WEBPACK FOOTER
// C:/Users/jogreen/Local Sites/power/app/public/wp-content/themes/sage-theme/node_modules/datatables.net-dt/js/dataTables.dataTables.mjs
// module id = 2
// module chunks = 0